import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mendatory-disclosure',
  templateUrl: './mendatory-disclosure.component.html',
  styleUrls: ['./mendatory-disclosure.component.scss']
})
export class MendatoryDisclosureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
